import { Component, OnInit } from "@angular/core";
import {
  NavController,
  ModalController,
  IonicModule,
  NavParams,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ContribuicoesProvider } from "src/app/services/contribuicoes/contribuicoes";
import { ContribuicoesContasBancariasPage } from "./contribuicoes-contas-bancarias/contribuicoes-contas-bancarias.page";
import { ContribuicoesMinhasPage } from "./contribuicoes-minhas/contribuicoes-minhas.page";
import { Router } from "@angular/router";
import { Browser } from "@capacitor/browser";
import { CommonModule, Location } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ImagePipe } from "src/app/pipes/image/image";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";

@Component({
  selector: "app-contribua",
  templateUrl: "./contribua.page.html",
  styleUrls: ["./contribua.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    LoadingSpinnerComponent,
    SemRegistroComponent,
  ],
})
export class ContribuaPage implements OnInit {
  configs: any = [];
  currentUrl: boolean;
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public translate: TranslateService,
    private location: Location,
    public contribuicoesProvider: ContribuicoesProvider,
    public modalCtrl: ModalController,
    public router: Router,
    public navParams: NavParams
  ) {
    const locationUrl = this.location.path();
    this.currentUrl = locationUrl === "/tabs/ContribuaPage" ? true : false;

    this.contribuicoesProvider.getConfigs().subscribe({
      next: (data) => {
        this.configs = data;

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      },
      error: (err) => {
        console.error("Erro ao buscar as configurações:", err);
        this.loaded = true;
      },
    });
  }

  ngOnInit() {}

  tratarClick(config: { tipo: string; texto: any }) {
    const actions: Record<string, () => void> = {
      CONTAS_BANCARIAS: () => this.abrirContas(config.texto),
      CONTRIBUA: () => this.abrirContribuir(),
      MINHAS: () => this.abrirMinhas(),
    };

    const action = actions[config.tipo];
    if (action) {
      action();
    }
  }

  async abrirContas(texto: any) {
    const modalPage = await this.modalCtrl.create({
      component: ContribuicoesContasBancariasPage,
      componentProps: texto,
    });
    modalPage.present();
  }

  async abrirMinhas() {
    const modalPage = await this.modalCtrl.create({
      component: ContribuicoesMinhasPage,
    });
    modalPage.present();
  }

  abrirContribuir() {
    this.contribuicoesProvider
      .registrarTokenTemporario()
      .subscribe(async (data) => {
        await Browser.open({ url: data });
      });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
